import React, { Component } from 'react';
import { GET_NETWORK_ICON, baseUrl, capitalizeFirstLetter } from '../../../../../../utils';


class ConnectAccount extends Component {
    state = {
        selectedAcc: null,
        accounts: [],
    }

    componentDidMount() {
        const { accountList } = this.props
        this.setState({ accounts: accountList })
    }

    createFeed = () => {
        const { selectedAcc } = this.state;
        const { accountList, createFeedFromPage } = this.props;
        createFeedFromPage( selectedAcc.acId, accountList[0].parent, selectedAcc.value2);
    }

    render() {
        const {loading, networkId, onBack } = this.props
        const { accounts } = this.state;

        return (
            <div className="action" id="feedsinstagram">
                <div className="d-flex flex-column-fluid main_content connect_your_account">
                    <div className="container py-18">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="middle_content">
                                    <div className="small_container">
                                        <div className="instaFacebookAuth card card-custom card-body">
                                            <div className="pt-5">
                                                <div className="d-flex flex-wrap align-items-center mb-6">
                                                    <div className="symbol symbol-60 flex-shrink-0 me-4">
                                                        <div className="symbol-label" style={{ backgroundImage: `url(${baseUrl(`icons/social-icons-square/${GET_NETWORK_ICON(networkId)}.svg`)})` }}>
                                                        </div>
                                                    </div>
                                                    <h3 className="d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3">
                                                        <span className="card-label font-weight-bolder text-dark">Connect Profile</span>
                                                        <span className="mt-1 font-weight-bold font-size-sm">Select the {capitalizeFirstLetter(GET_NETWORK_ICON(networkId))} Profile You’d Like to Connect</span>
                                                    </h3>
                                                </div>
                                            </div>
                                            <div className="noLoader" id="FeedInstagramForm">
                                                <div className="instaConnectthroughfacebook_radio_list md-radio-list">
                                                    <div className="row">
                                                        {accounts && accounts.length ? accounts.map((acc, index) => (
                                                            <div className="col-md-6" key={acc.id}>
                                                                <label
                                                                    // htmlFor={`user${acc.accountId}`}
                                                                    id={`user-${acc.id}`} className="user_row__ w-100 border-bottom p-3 m-0">
                                                                    <div className="d-flex flex-wrap align-items-center w-100">
                                                                        <span className={`symbol symbol-lg-45 symbol-30 random_color-${index + 1} symbol-circle me-4`}>
                                                                            <span className="symbol-label font-size-h4 font-weight-bold">{acc.value2[0].toUpperCase()}</span>
                                                                        </span>
                                                                        <div className="d-flex flex-column flex-grow-1 pe-3">
                                                                            <h5 className="text-dark-75 font-weight-bolder font-size-lg m-0">{acc.value2}</h5>
                                                                        </div>
                                                                        <div className="d-flex align-items-center py-lg-0 py-2">
                                                                            <span className="option-control">
                                                                                <span className="radio radio-outline radio-primary">
                                                                                    <input id={`user${acc.id}`} onChange={() => this.setState({ selectedAcc: acc })} className="md-radiobtn" type="radio" name="pageSelect" />
                                                                                    <span></span>
                                                                                </span>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </label>
                                                            </div>
                                                        )) : null}
                                                    </div>
                                                </div>
                                                <div className="d-flex justify-content-end border-top pt-10">
                                                    <div onClick={onBack} className="btn btn-secondary me-4">Cancel</div>
                                                    <button className={`btn btn-primary ${loading ? 'spinner spinner-right disabled' : ''}`} type="button" name="submit" style={{ minWidth: "100px" }} onClick={() =>this.createFeed()}>Create Feed</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


export default ConnectAccount
